import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TrackingCrad from '../TrackingCard/TrackingCrad';
import 'react-virtualized/styles.css'; // only needs to be imported once
import {Toto} from '../TrackingCradList/toto';
import { List,InfiniteLoader,AutoSizer,CellMeasurerCache,CellMeasurer } from 'react-virtualized';
import 'react-virtualized/styles.css'
import {groupBy} from '../../../../util/util';
import $ from 'jquery';
import { runInDebugContext } from 'vm';
let remoteRowCount=10;
// List data as an array of strings
let list = [];
let listGroup = [];
let trackListGroup ;
let cache = new CellMeasurerCache({});
let cacheG = new CellMeasurerCache({});

class TrackingCradList extends Component {
    constructor(props) {
		super(props);

		this.state = {
            trackHistoryList : this.props.trackHistoryList,
            trackList : this.props.trackList,
            groupName :[]
        };
    }
    componentDidMount(){
        const {trackList,trackHistoryList,isGroupOrder} = this.props;
        if(trackList){
            // if(isGroupOrder){
            //     let g = groupBy(trackList, function(item)
            //     {
            //         return [item.device_info.device_group];
            //     });
            //     listGroup = g;
            // }else{
                //list = trackList;
            // }
            cacheG.clearAll(); 
        }
        else  if(trackHistoryList)
            list = trackHistoryList.tracker;
    }

    componentDidUpdate(){
  
    }
    setGroup(isGroup){
        if(isGroup)
            cacheG.clearAll(); 
        else
            cache.clearAll(); 
    }

    handleCardSelect(index,device_no,lat,lng){
        if(this.props.trackHistoryList||this.props.trackList)
            this.props.onSelect(index,device_no,lat,lng);
            

        this.setCarSelect(index);
    }
    setCarSelect(index){
        console.log("setCarSelect",index);
        
        if(runInDebugContext == -1){
            $(".make-3D>div").removeClass("cardSelect");
            $(".dvSub").removeClass("cardSelect");
            return;
        }
        let scrollToIndex = Math.min(
            list.length - 1,
            parseInt(index, 10),
        );
    
        if (isNaN(scrollToIndex)) {
            scrollToIndex = undefined;
        }
        console.log("scrollToIndex",scrollToIndex)
        this.setState({scrollToIndex});

        let id = "";
        if(this.props.trackHistoryList)
            id = "th" + index;
        else if(this.props.trackList)
            id = "t" + index;
        if(list.length>1){
            $(".make-3D>div").removeClass("cardSelect");
            $(".dvSub").removeClass("cardSelect");
            $("#"+id+">div").addClass("cardSelect");
            $("#"+id+"dvSub").addClass("cardSelect");
        }
        
        if($( document ).width()>756)
            $("#txt"+id).focus();
    }
    setCarSelectImei(imei){
        if(this.props.trackList){
            for(let i=0;i<this.props.trackList.length;i++){
                if(this.props.trackList[i].imei == imei){
                    this.setCarSelect(i);
                    console.log("setCarSelectImei",i)
                    return;
                }
            }
        }
    }
    getIndexArrByValue(arr,v){
        for(let i=0;i<arr.length;i++){
            if(arr[i]==v){
                return i;
            }
        }
        return -1;
    }
    handleToggleGroup(groupName){
        console.log("cache.clearAll(); ");
        let g = this.state.groupName;
        let n = this.getIndexArrByValue(g,groupName);
        if(n>-1)
            g.splice(n,1)
        else
            g.push(groupName);
        cacheG.clearAll(); 
        this.setState({groupName:g});
        //cache.clearAll(); 
        //cache.clear(0,0)
        //this.props.onCardGroupSelect(-1);
       
    }
    rowRealRenderer(){
        console.log("rowRealRenderer")
        let rows = [];
        if(!trackListGroup || trackListGroup==null)
            return rows;
        
        for(let i=0;i<trackListGroup.length;i++){
            let a= {index:i,isScrolling:null,key:null,parent:null,style:null};
            rows.push(this.rowRenderer(a,i,true));
        }
        return rows;
    }
    rowRenderer ({
        index, isScrolling, key, parent, style 
    },indexGroup,isReal) {
            console.log("rowRenderer")
            const {trackList,trackHistoryList,isGroupOrder} = this.props;
            let rows =[];
            if(trackHistoryList ){
                rows.push(<TrackingCrad key = {"thl" + index} tname={"th" + index} trackHistory = {trackHistoryList.tracker[index]} index={index} 
                onSelect = {this.handleCardSelect.bind(this)} info={trackHistoryList}
                onMarkPointClick = {this.handleMarkPointClick.bind(this)}
                />)
            }
            if(trackList){


                if(!isGroupOrder){
                    rows.push(<TrackingCrad key = {"tl" + index} tname={"t" + index} track = {trackList[index]} index={index} 
                    onSelect = {this.handleCardSelect.bind(this)}
                    onMarkPointClick = {this.handleMarkPointClick.bind(this)}/>)
                }else{
                    
                    let sRows = [];
                    if(isReal)
                        index = indexGroup;
                    for(let i = 0 ; i < trackListGroup[index].length ; i++){
            
                        console.log("indexGroup",trackListGroup[index][i].index,trackListGroup)
                        sRows.push(<TrackingCrad key = {"tl" + trackListGroup[index][i].index} tname={"t" + trackListGroup[index][i].index} track = {trackListGroup[index][i]} 
                        index={trackListGroup[index][i].index} 
                        onSelect = {this.handleCardSelect.bind(this)}
                        onMarkPointClick = {this.handleMarkPointClick.bind(this)}
                        />)
                    }
                    rows.push(<div className="panel-group " id="accordion" role="tablist" aria-multiselectable="false">
                        <div className="panel panel-default">
                        <div className="panel-heading" role="tab" id="headingOne" onClick={this.handleToggleGroup.bind(this)}>
                            <h4 className="panel-title">
                            <a role="button" data-toggle="collapse" data-parent="#accordion" href={"#collapse"+index} aria-expanded="true" aria-controls={"collapse"+index}>
                                {trackListGroup[index][0].device_info.device_group == ""?"ไม่ระบุกลุ่ม":trackListGroup[index][0].device_info.device_group}
                            </a>
                            </h4>
                        </div>
                        <div id={"collapse"+index} className="panel-collapse collapse in show" role="tabpanel" aria-labelledby={"heading"+index}>
                            <div className="panel-body">
                                {sRows}
                            </div>
                        </div>
                        </div>
                        
                
                    </div>)
                }
                
                
            }
            return (
                !isReal?
                <CellMeasurer
                    cache={cache}
                    columnIndex={0}
                    key={key}
                    parent={parent}
                    rowIndex={index}
                    >
                {({ measure }) => (
                    <div 
                        
                        key={key}
                        style={style}
                    >
                        {rows}
                    </div>
                )}
                </CellMeasurer>
                :<div style={{width:"100%"}}>{rows}</div>
            )
    }

    rowRendererGroup ({
        index, isScrolling, key, parent, style 
    }) {
            console.log("rowRendererGroup")
            const {trackList,trackHistoryList,isGroupOrder} = this.props;
            let rows =[];
            if(trackList){
                    
                    // let sRows = [];
                    // for(let i = 0 ; i < trackListGroup[index].length ; i++){
            
                    //     console.log("indexGroup",trackListGroup[index][i].index,trackListGroup)
                    //     sRows.push(<TrackingCrad key = {"tl" + trackListGroup[index][i].index} tname={"t" + trackListGroup[index][i].index} track = {trackListGroup[index][i]} 
                    //     index={trackListGroup[index][i].index} 
                    //     onSelect = {this.handleCardSelect.bind(this)}/>)
                    // }
                    // rows.push(<div className="panel-group" id="accordion" role="tablist" aria-multiselectable="false">
                    //     <div className="panel panel-default">
                    //     <div className="panel-heading" role="tab" id={"heading"+index} onClick={this.handleToggleGroup.bind(this)}>
                    //         <h4 className="panel-title">
                    //         <a role="button" data-toggle="collapse" data-parent="#accordion" href={"#collapse"+index} aria-expanded="true" aria-controls={"collapse"+index}>
                    //             {trackListGroup[index][0].device_info.device_group == ""?"ไม่ระบุกลุ่ม":trackListGroup[index][0].device_info.device_group}
                    //         </a>
                    //         </h4>
                    //     </div>
                    //     <div id={"collapse"+index} className="panel-collapse collapse in show" role="tabpanel" aria-labelledby={"heading"+index}>
                    //         <div className="panel-body">
                    //             {sRows}
                    //         </div>
                    //     </div>
                    //     </div>
                        
                
                    // </div>)
                let n = this.getIndexArrByValue(this.state.groupName,listGroup[index].device_info.device_group);
                if(index==0 || listGroup[index].device_info.device_group != listGroup[index-1].device_info.device_group){
                    rows.push(
                        <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="false">
                            <div className="panel panel-default">
                                <div className="panel-heading" role="tab" id={"heading"+index} onClick={this.handleToggleGroup.bind(this,listGroup[index].device_info.device_group)}>
                                    <h4 className="panel-title">
                                    <a role="button" data-toggle="collapse" data-parent="#accordion" href={"#collapse"+index} aria-expanded="true" aria-controls={"collapse"+index}>
                                        {listGroup[index].device_info.device_group == ""?"ไม่ระบุกลุ่ม":listGroup[index].device_info.device_group}
                                    </a>
                                    </h4>
                                </div>
                                <div id={"collapse"+index} className="panel-collapse collapse in show" role="tabpanel" aria-labelledby={"heading"+index}>
                                    <div className="panel-body">
                                    
                                    </div>
                                </div>
                            </div>
                            
                    
                        </div>)
                    if(n==-1)
                        rows.push(
                            <TrackingCrad key = {"tl" + index} tname={"t" + index} track = {listGroup[index]} 
                            index={index} 
                            onSelect = {this.handleCardSelect.bind(this)}
                            onMarkPointClick = {this.handleMarkPointClick.bind(this)}/>
                        )
                }else{
                    if(n==-1)
                        rows.push(
                            <TrackingCrad key = {"tl" + index} tname={"t" + index} track = {listGroup[index]} 
                            index={index} 
                            onSelect = {this.handleCardSelect.bind(this)}
                            onMarkPointClick = {this.handleMarkPointClick.bind(this)}/>
                        
                        )
                }
                    
                    
                
            }
            return (
                <CellMeasurer
                    cache={cacheG}
                    columnIndex={0}
                    key={key}
                    parent={parent}
                    rowIndex={index}
                    >
                {({ measure }) => (
                    <div 
                        
                        key={key}
                        style={style}
                    >
                        {rows}
                    </div>
                )}
                </CellMeasurer>
            )
    }
    
    loadMoreRows ({ startIndex, stopIndex }) {

    }
    
    isRowLoaded ({ index }) {
    return !!list[index];
    }
    isRowLoadedGroup ({ index }) {
        return !!listGroup[index];
    }

    trackReal(){
        const {trackList} = this.props;
        list =[];
       console.log("xxx", this.isRowLoaded({index:0}));
        let rows =[];
        for(let index=0;index<trackList.length;index++){
            rows.push(<TrackingCrad key = {"ttl" + index} tname={"tt" + index} track = {trackList[index]} index={index} 
                    onSelect = {this.handleCardSelect.bind(this)}
                    onMarkPointClick = {this.handleMarkPointClick.bind(this)}
                    />)
        }
        return rows;
        
    }
    handleMarkPointClick(){
        if(this.props.onMarkPointClick)
            this.props.onMarkPointClick();
    }
    render () {
        const {trackList,trackHistoryList,isGroupOrder} = this.props;
        
        let rows = [];
        let w = 510;
        trackListGroup = undefined;
         if(trackHistoryList){
        //     for(let i = 0 ;i < trackHistoryList.length ;i++){
        //         rows.push(<TrackingCrad key = {"thl" + i} tname={"th" + i} trackHistory = {trackHistoryList[i]} index={i} 
        //         onSelect = {this.handleCardSelect.bind(this)}/>)
                 //w = 440;
                 list = trackHistoryList.tracker;
                 w= $(window).height() - 190;
                 //cache.clearAll(); 
        //     }
         }
         if(trackList){
        //     for(let i = 0 ;i < trackList.length ;i++){
        //         rows.push(<TrackingCrad key = {"tl" + i} tname={"t" + i} track = {trackList[i]} index={i} 
        //         onSelect = {this.handleCardSelect.bind(this)}/>)
        //     }
           
            if(isGroupOrder){
                
                // trackListGroup = groupBy(trackList, function(item)
                // {
                //     return [item.device_info.device_group];
                // });
                // let index = 0;
                // for(let i=0;i<trackListGroup.length;i++){
                //     for(let j=0;j<trackListGroup[i].length;j++){
                //         trackListGroup[i][j].index = index++;
                //     }
                // }
               
                listGroup = trackList;
                // cacheG.clearAll(); 
            }else{
                // cache.clearAll();
                if(list.length == 0 && trackList.length > 200)
                    list = trackList.slice(0,199);//[trackList[0],trackList[1],trackList[2],trackList[3],trackList[4],trackList[5],trackList[6],trackList[7],trackList[8]];
                else
                    list = trackList;
            }
                 
            if(!this.props.isShowTackDetail)
                w= $(window).height() - 155;
            else
                w= ($(window).height()/2) - 40;
         }
         //cache.clearAll(); 
         console.log("toto xxx",trackList,trackListGroup,trackHistoryList,isGroupOrder) 
         
        
        //  if(trackList && !isGroupOrder && trackList.length<200)
                
        //        return this.trackReal()
                
            
        return (
         
           
            
            trackList && isGroupOrder && trackList.length<0?
                
                this.rowRealRenderer()
                
            : 
            !isGroupOrder || trackHistoryList?
            //    <div style={{height:"100vh"}}>
                <InfiniteLoader
                isRowLoaded={this.isRowLoaded.bind(this)}
                loadMoreRows={this.loadMoreRows.bind(this)}
                rowCount={remoteRowCount}>
                {({ onRowsRendered, registerChild }) => (
                <AutoSizer disableHeight>
                {({width}) => (
                <List      
                    height={w}
                    onRowsRendered={onRowsRendered}
                    ref={registerChild}
                    rowCount={list.length}
                    deferredMeasurementCache={cache}
                    rowHeight={cache.rowHeight}
                    rowRenderer={this.rowRenderer.bind(this)}
                    width={width-10}
                    scrollToIndex={this.state.scrollToIndex}
                />
                )}
                </AutoSizer>
                )}
                </InfiniteLoader>
                // </div>
                :
                    <InfiniteLoader
                    isRowLoaded={this.isRowLoadedGroup.bind(this)}
                    loadMoreRows={this.loadMoreRows.bind(this)}
                    rowCount={remoteRowCount}>
                    {({ onRowsRendered, registerChild }) => (
                    <AutoSizer disableHeight>
                    {({width}) => (
                    <List      
                        height={w}
                        onRowsRendered={onRowsRendered}
                        ref={registerChild}
                        rowCount={listGroup.length}
                        deferredMeasurementCache={cacheG}
                        rowHeight={cacheG.rowHeight}
                        rowRenderer={this.rowRendererGroup.bind(this)}
                        width={width}
                        scrollToIndex={this.state.scrollToIndex}
                    />
                    )}
                    </AutoSizer>
                    )}
                    </InfiniteLoader>
            
        )
    }
}
TrackingCradList.defaultProps = {
  
}

TrackingCradList.propTypes = {
    trackList: PropTypes.object,
}
export default TrackingCradList



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/TrackingCradList/TrackingCradList.js